var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalanceCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 33.6V40.32C34 41.328 33.32 42 32.3 42H1.7C0.68 42 0 41.328 0 40.32V18.48C0 17.472 0.68 16.8 1.7 16.8H32.3C33.32 16.8 34 17.472 34 18.48V25.2H26.35C23.97 25.2 22.1 27.048 22.1 29.4C22.1 31.752 23.97 33.6 26.35 33.6H34ZM26.35 27.72C25.33 27.72 24.65 28.392 24.65 29.4C24.65 30.408 25.33 31.08 26.35 31.08C27.37 31.08 28.05 30.408 28.05 29.4C28.05 28.392 27.37 27.72 26.35 27.72ZM22.95 0C20.57 0 18.7 1.848 18.7 4.2C18.7 6.552 20.57 8.4 22.95 8.4C25.33 8.4 27.2 6.552 27.2 4.2C27.2 1.848 25.33 0 22.95 0ZM16.49 13.44C16.83 12.768 17 12.096 17 11.256C17 8.4 14.79 6.216 11.9 6.216C9.01 6.216 6.8 8.4 6.8 11.256C6.8 12.096 6.97 12.768 7.31 13.44H16.49Z",
    fill: "#1BA557"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceCard);
export default __webpack_public_path__ + "static/media/BalanceCard.1049bd1647cb794b27628b8c59f96097.svg";
export { ForwardRef as ReactComponent };